import React, { useEffect, useState } from 'react';

import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Fragment } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import SweetAlert from 'react-bootstrap-sweetalert';

import { useParams } from 'react-router-dom';

import MecanicaDetail from 'components/Tvendo/Sale/QuotaBPartner/Mecanica/MecanicaDetails/List';
import MecanicaCanal from 'components/Tvendo/Sale/QuotaBPartner/Mecanica/MecanicaCanal/List';
import { Toasty, useToasty } from 'hooks/Toasty';
import { wsRemove } from 'services/WService';

//Tabs
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import { wsGet } from 'services/WService';
import { wsFindBy } from 'services/WService';

const useStyles = makeStyles(styles);

export default function () {
  const claseStyleTab = useStyleTabs();
  const classes = useStyles();

  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [notify, showNotify] = useToasty();

  const themeTab = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirm(entity, id, reload) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Esta seguro de eliminar!"
        onConfirm={() => {
          remove(entity, id, reload);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  async function remove(entity, id, reload) {
    let response = await wsRemove(entity, id);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  //#region Listados de api
  const [mecanica, setMecanica] = useState({});
  const [mDetails, setMDetails] = useState([]);
  const [mCanals, setMCanals] = useState([]);

  async function getMecanica() {
    let response = await wsGet('sale/mecanica-venta', id);
    if (response.success) {
      setMecanica(response.data);
    }
  }
  async function getMecanicaDetail() {
    let response = await wsFindBy('sale/mecanica-detalle', { colgate_mecanica_venta_id: mecanica.id });
    if (response.success) setMDetails(response.data);
  }
  async function getMecanicaCanal() {
    let response = await wsFindBy('sale/mecanica-canal', { colgate_mecanica_venta_id: mecanica.id });
    if (response.success) setMCanals(response.data);
  }

  useEffect(() => {
    getMecanica();
  }, []);

  useEffect(()=> {
    if(mecanica.id){
      getMecanicaDetail();
      getMecanicaCanal();
    }
  },[mecanica.id]);

  return (
    <Fragment>
      <Toasty action={notify} />
      {alert}
      {id != 0 ? (
        <Fragment>
          <h4 style={{ fontWeight: 'bold' }}>Mecanica: {mecanica.mecanica}</h4>
          <div className={claseStyleTab.root}>
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                textColor="secondary"
                aria-label="Tabs"
                indicatorColor="secondary"
              >
                <Tab label="Distribución" {...indexTab(0)} />
                <Tab label="Rangos" {...indexTab(1)} />
              </Tabs>
            </AppBar>
            <SwipeableViews
              axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              <TabPanel value={value} index={0} dir={themeTab.direction}>
                <MecanicaCanal
                  id={id}
                  showNotify={showNotify}
                  confirm={confirm}
                  mCanals={mCanals}
                  setMCanals={setMCanals}
                  mecanica={mecanica}
                  reload={getMecanicaCanal}
                />
              </TabPanel>
              <TabPanel value={value} index={1} dir={themeTab.direction}>
                <MecanicaDetail
                  id={id}
                  showNotify={showNotify}
                  confirm={confirm}
                  mDetails={mDetails}
                  setMDetails={setMDetails}
                  mecanica={mecanica}
                  reload={getMecanicaDetail}
                />
              </TabPanel>
            </SwipeableViews>
          </div>
        </Fragment>
      ) : undefined}
    </Fragment>
  );
}
